import { render, staticRenderFns } from "./ActivatePage.vue?vue&type=template&id=2b37d672"
import script from "./ActivatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivatePage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports